<template>
  <div class="content">
    <div class="site-content container">
      <div class="sidebar">
        <SidebarLight />
      </div>
      <div class="main-content">
        <slot></slot>
      </div>
    </div>
    <div id="footer-container">
      <TopFooter />
      <Footer />
    </div>
  </div>
</template>

<script>
import TopFooter from "@/common/components/structure/TopFooter";
import Footer from "@/common/components/structure/Footer";
import SidebarLight from "@/common/components/structure/SidebarLight";

export default {
  components: {
    TopFooter,
    Footer,
    SidebarLight
  }
};
</script>

<style scoped>
.content {
  display: flex;
  width: 100%;
  flex-direction: column;
}
.sidebar {
  border: solid 1px #e9e9e9;
  width: 280px;
}
.site-content {
  width: 100%;
  display: flex;
}
.header-content {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.main-content {
  width: 100%;
}
.header {
  border-bottom: solid 1px #e9e9e9;
  display: flex;
  justify-content: flex-end;
}
@media (max-width: 800px) {
  .sidebar {
    transform: translateX(-100%);
    position: fixed;
    transition: all 0.3s;
  }
}
</style>